import React from "react";
import { Grid, Typography, Card, Link } from "@material-ui/core";
import { Component } from "react";

class GameItem extends Component {
  render() {
    return (
      <Grid item xs={12} sm={6} md={4}>
        <Card variant="outlined" height="100%" p={2}>
          <Link href={this.props.item.playstoreUrl} target="_blank" rel="noopener">         
          <Grid container spacing={2} alignItems="center">
            <Grid item>
          <img src={this.props.item.image} width="100%" height="100%" alt={this.props.item.name}/>
          </Grid>
            <Grid item width="100%">
              <Typography variant="h5" textAlign="center" fontWeight="bold">{this.props.item.name}</Typography>
            </Grid>
          </Grid>
          </Link>
          {/*<Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
          <Image src="/assets/images/google-play-badge2.png" width={498} height={167} />
          </Grid>   
          <Grid item xs={12} sm={6}>
              
          <Image src="/assets/images/app-store-badge.png" width={498} height={167} />
  
          </Grid>
          </Grid>*/}
        </Card>
      </Grid>
    );
  }
}
  
export default GameItem